import { Component, Input } from '@angular/core';

import { UICallLogEvent } from '../../models/call-history.model';

@Component({
  selector: 'app-call-recording',
  templateUrl: './call-recording.component.html',
  styleUrls: ['./call-recording.component.scss'],
})
export class CallRecordingComponent {
  @Input() callItem: UICallLogEvent;

  public openLink(link: string): void {
    window.open(link, '_blank');
  }
}
